module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Edition Closed.feb15367.png";